import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';

const ServicesPage: React.FC = () => {
  const services = [
    {
      title: 'Freight Forwarding',
      description: 'Comprehensive freight forwarding services for seamless international shipping solutions.',
      detailedDescription: 'Our freight forwarding services provide end-to-end solutions for your shipping needs. We handle everything from documentation to final delivery, ensuring your cargo reaches its destination safely and on time. With our extensive network of partners and carriers, we offer competitive rates and reliable service across all major trade routes.',
      image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1200&q=80'
    },
    {
      title: 'Transit',
      description: 'Efficient transit services ensuring smooth cargo movement across borders.',
      detailedDescription: 'Our transit services facilitate the smooth movement of goods through multiple countries and customs zones. We specialize in handling complex transit documentation, coordinating with various authorities, and ensuring compliance with international trade regulations. Our experienced team manages every aspect of transit logistics to minimize delays and costs.',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&q=80'
    },
    {
      title: 'Air Cargo',
      description: 'Fast and reliable air cargo services for time-sensitive shipments worldwide.',
      detailedDescription: 'When speed matters, our air cargo services deliver. We provide express air freight solutions for urgent shipments, connecting you to major airports worldwide. Our partnerships with leading airlines ensure priority handling, competitive rates, and reliable delivery schedules. From small packages to large cargo, we handle it all with precision and care.',
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1200&q=80'
    },
    {
      title: 'Imports and Export',
      description: 'Complete import and export handling with full regulatory compliance.',
      detailedDescription: 'Navigate the complexities of international trade with our comprehensive import and export services. We handle all aspects of cross-border trade, from documentation to customs clearance, ensuring your goods move smoothly across borders. Our expertise in trade regulations and compliance helps you avoid costly delays and penalties.',
      image: 'https://images.unsplash.com/photo-1494412519320-aa613dfb7738?w=1200&q=80'
    },
    {
      title: 'Custom Clearance',
      description: 'Expert customs clearance services ensuring smooth and compliant cargo processing.',
      detailedDescription: 'As a licensed Customs House Agency, we provide expert customs clearance services that ensure your cargo moves through customs quickly and efficiently. Our team of licensed customs brokers understands the intricacies of customs regulations and works closely with authorities to expedite clearance while ensuring full compliance.',
      image: '/images/custom-clearance-documents.jpg'
    },
    {
      title: 'Cargo Logistics',
      description: 'End-to-end cargo logistics management for all your supply chain needs.',
      detailedDescription: 'Our comprehensive cargo logistics services provide complete supply chain solutions from origin to destination. We coordinate every aspect of your cargo movement, including transportation, warehousing, inventory management, and final delivery. Our integrated approach ensures efficiency, cost savings, and reliability throughout your supply chain.',
      image: '/images/Cargo logistics.jpg'
    },
    {
      title: 'Warehousing',
      description: 'Secure warehousing facilities with modern storage and inventory management.',
      detailedDescription: 'Our state-of-the-art warehousing facilities provide secure, climate-controlled storage for your goods. With advanced inventory management systems, we ensure accurate tracking, efficient handling, and timely distribution. Our warehouses are strategically located for easy access to ports and transportation hubs.',
      image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80'
    },
    {
      title: 'Destination Management',
      description: 'Complete destination management services ensuring smooth final delivery.',
      detailedDescription: 'Our destination management services ensure your cargo reaches its final destination smoothly and efficiently. We coordinate local transportation, handle final customs procedures, manage delivery schedules, and provide comprehensive support throughout the delivery process. Our local expertise ensures seamless operations at destination.',
      image: 'https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=1200&q=80'
    },
    {
      title: 'Haulage',
      description: 'Reliable haulage services for ground transportation of all cargo types.',
      detailedDescription: 'Our haulage services provide reliable ground transportation for all types of cargo. With a modern fleet of vehicles and experienced drivers, we ensure safe and timely delivery of your goods. We handle everything from local deliveries to long-distance haulage, with specialized equipment for different cargo types.',
      image: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1200&q=80'
    }
  ];

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1 className="page-title">Our Services</h1>
          <p className="page-subtitle">
            Comprehensive logistics solutions tailored to your business needs. 
            We provide end-to-end services to ensure your cargo reaches its destination safely and on time.
          </p>
        </div>
      </div>

      <div className="container">
        {services.map((service, index) => (
          <div key={index} className="service-detail-section">
            <div className="service-detail-content">
              <div className="service-detail-images">
                <div className="service-detail-image-wrapper">
                  <img src={service.image} alt={service.title} className="service-detail-image" />
                </div>
              </div>

              <div className="service-detail-text">
                <h2 className="service-detail-title">{service.title}</h2>
                <p className="service-detail-short">{service.description}</p>
                <p className="service-detail-description">{service.detailedDescription}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="services-cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Contact us today to discuss your logistics needs and discover how we can help your business grow.</p>
          <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
